import React from 'react';
import { StyledErrorState } from '../StyledErrorState';
import type { ErrorWrapper } from './errorWrapperTypes';
import { isEmpty } from 'lodash';
import { usePortfolioMultiFiltering } from '../../../blocks/utils/hooks/use-portfolio-multi-filtering';
import { useRecoilValue } from 'recoil';
import { blockInfoGraphicType, blockSettings } from 'venn-state';

const getPrefix = (blockType: string, infoGraphicType: string) => {
  switch (blockType) {
    case 'PORTFOLIO_COMPARISON':
      return 'Portfolio Comparison';

    case 'PORTFOLIO_BREAKDOWN':
      return 'Portfolio Composition';

    case 'FINANCIAL_PERFORMANCE_INDICATORS':
      if (infoGraphicType?.includes('PIVOTED_GRID')) {
        return 'Financial performance indicators';
      }
      break;

    case 'PORTFOLIO_CONTRIBUTION':
      if (infoGraphicType?.includes('GRID')) {
        return 'Portfolio Contribution';
      }
      break;
  }

  return undefined;
};

export const NoStrategyLevelsSelectedErrorWrapper: ErrorWrapper = ({ blockId, children }) => {
  const { filter, hasMultiLevelPortfolioFiltering } = usePortfolioMultiFiltering(blockId);
  const settings = useRecoilValue(blockSettings(blockId));
  const infoGraphicType = useRecoilValue(blockInfoGraphicType(blockId));
  const blockType = settings.customBlockType;
  const prefix = getPrefix(blockType, infoGraphicType as string);

  if (hasMultiLevelPortfolioFiltering && prefix && filter?.filterType === 'CUSTOM' && isEmpty(filter?.levels)) {
    return (
      <StyledErrorState
        selectedRefId={blockId}
        header={`${prefix} must have at least 1 strategy level selected`}
        message="Please select an option from the Strategy Levels dropdown."
      />
    );
  }

  return children;
};
